import type { AnimationDataV2 } from './types/v2';
import type { AnimationDataV3, StageIdV3 } from './types/v3';

/**
 * V2 → V3. Two related changes:
 *
 *   1. `userPrompt` is dropped — the "describe your video" prompt is
 *      client-only now and was never load-bearing for renders.
 *   2. The `'describe-video'` and `'script'` stages were merged into a
 *      single `'generate-script'` stage. We migrate any saved
 *      `activeStageId` accordingly so users land on a real stage.
 *
 *   3. `contentSource` is added and set to `'describe'` for migrated blobs
 *      — every v2 blob was authored before the paste tab existed.
 */
export function v2ToV3(input: AnimationDataV2): AnimationDataV3 {
    const { userPrompt: _userPrompt, activeStageId, ...rest } = input;

    const migratedStageId: StageIdV3 | undefined =
        activeStageId === 'describe-video' || activeStageId === 'script'
            ? 'generate-script'
            : activeStageId;

    return {
        ...rest,
        version: 3,
        contentSource: 'describe',
        activeStageId: migratedStageId,
    };
}
